import { UploadFileItem } from '../BatchUpload'

export interface PreviewModalOption {
  fileUrl: string
  open: boolean
}
interface State {
  uploadFileList: UploadFileItem[]
  previewModalOption: PreviewModalOption
  isLoading: boolean
}
type ActionType =
  | 'setUploadFileListAction'
  | 'setPreviewModalOptionAction'
  | 'setIsLoadingAction'
  | 'resetStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  uploadFileList: [],
  previewModalOption: {
    fileUrl: '',
    open: false,
  },
  isLoading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setUploadFileListAction':
      newstate.uploadFileList = action.payload
      return newstate
    case 'setPreviewModalOptionAction':
      newstate.previewModalOption = action.payload
      return newstate
    case 'setIsLoadingAction':
      newstate.isLoading = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}
/**
 * 当前下载队列
 * @param val
 * @returns
 */
export const setUploadFileListAction = (val: UploadFileItem[]): Action => ({
  type: 'setUploadFileListAction',
  payload: val,
})

export const setPreviewModalOptionAction = (
  val: PreviewModalOption,
): Action => ({
  type: 'setPreviewModalOptionAction',
  payload: val,
})

export const setIsLoadingAction = (val: boolean): Action => ({
  type: 'setIsLoadingAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
import { UploadFileItem } from '../BatchUpload'

export interface PreviewModalOption {
  fileUrl: string
  open: boolean
}
interface State {
  uploadFileList: UploadFileItem[]
  previewModalOption: PreviewModalOption
  isLoading: boolean
}
type ActionType =
  | 'setUploadFileListAction'
  | 'setPreviewModalOptionAction'
  | 'setIsLoadingAction'
  | 'resetStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  uploadFileList: [],
  previewModalOption: {
    fileUrl: '',
    open: false,
  },
  isLoading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setUploadFileListAction':
      newstate.uploadFileList = action.payload
      return newstate
    case 'setPreviewModalOptionAction':
      newstate.previewModalOption = action.payload
      return newstate
    case 'setIsLoadingAction':
      newstate.isLoading = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}
/**
 * 当前下载队列
 * @param val
 * @returns
 */
export const setUploadFileListAction = (val: UploadFileItem[]): Action => ({
  type: 'setUploadFileListAction',
  payload: val,
})

export const setPreviewModalOptionAction = (
  val: PreviewModalOption,
): Action => ({
  type: 'setPreviewModalOptionAction',
  payload: val,
})

export const setIsLoadingAction = (val: boolean): Action => ({
  type: 'setIsLoadingAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
